import { fork, call, put, take } from 'redux-saga/effects';

import * as actionTypes from 'constants/ActionTypes';
import api from "services";

/**
 * Base saga
 * */
export function* baseSaga({ data, actionName, methodApi, notificationOptions }) {
    const response = yield call(api[methodApi]);

    if (response.status === 200) {
        yield put({
            type: actionTypes[actionName].SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes[actionName].FAILURE,
        errors: response.errors,
    });

    return response;
}

export function callBaseSaga({ actionName, methodApi, notificationOptions }) {
    return function* watchBaseSaga() {
        while (true) {
            const {data} = yield take(actionTypes[actionName].REQUEST);
            yield fork(baseSaga, {data, actionName, methodApi, notificationOptions});
        }
    }
}


// WEBPACK FOOTER //
// ./app/sagas/base/index.js